// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import tippy        from 'tippy.js';

export default class Tooltip extends WebComponent {
	constructor() {
		super();

		this.tip = null;
	}

	didMount() {
		this.tip = tippy(this.element, {
			arrow: true,
			theme: 'esp',
		});
	}

	willUnMount() {
		this.tip.destroy();
	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Tooltip.js